const membersActionTypes = {
  FETCH_MEMBERS: 'FETCH_MEMBERS',
  FETCH_MEMBERS_SUCCESS: 'FETCH_MEMBERS_SUCCESS',
  FETCH_MEMBERS_FAIL: 'FETCH_MEMBERS_FAIL',
  FETCH_MEMBER: 'FETCH_MEMBER',
  FETCH_MEMBER_SUCCESS: 'FETCH_MEMBER_SUCCESS',
  FETCH_MEMBER_FAIL: 'FETCH_MEMBER_FAIL',
  UPDATE_USER_BLOCK_STATUS: 'UPDATE_USER_BLOCK_STATUS',
  UPDATE_USER_BLOCK_STATUS_SUCCESS: 'UPDATE_USER_BLOCK_STATUS_SUCCESS',
  UPDATE_USER_BLOCK_STATUS_FAIL: 'UPDATE_USER_BLOCK_STATUS_FAIL',
  FETCH_MEMBER_TRANSACTIONS: 'FETCH_MEMBER_TRANSACTIONS',
  FETCH_MEMBER_TRANSACTIONS_SUCCESS: 'FETCH_MEMBER_TRANSACTIONS_SUCCESS',
  FETCH_MEMBER_TRANSACTIONS_FAIL: 'FETCH_MEMBER_TRANSACTIONS_FAIL',
  SET_FILTERED_MEMBER_TRANSACTIONS: 'SET_FILTERED_MEMBER_TRANSACTIONS',
  UPDATE_USER_POINTS: 'UPDATE_USER_POINTS',
  UPDATE_USER_POINTS_SUCCESS: 'UPDATE_USER_POINTS_SUCCESS',
  UPDATE_USER_POINTS_FAIL: 'UPDATE_USER_POINTS_FAIL',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  ADD_USER_FAIL: 'ADD_USER_FAIL',
  RESET_MEMBER_TRANSACTION: 'RESET_MEMBER_TRANSACTION',
};

export default membersActionTypes;
